import React from 'react';

export default function ResultsBlock2Context() {
  return (
    <section className="py-24 md:py-24 px-6 md:px-16 bg-paper border-b border-line">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-16 max-w-5xl mx-auto">
          <div className="text-[14px] font-semibold text-brand tracking-widest uppercase mb-6">
            ORIGEN DEL APRENDIZAJE
          </div>
          <h2 className="text-[32px] md:text-[48px] lg:text-[48px] font-bold text-ink mb-8 tracking-tight leading-[1.2]">
            Dos pilotos distintos. Un mismo aprendizaje.
          </h2>
          <p className="text-[16px] md:text-[20px] text-slate leading-[1.6] max-w-3xl mx-auto mb-16">
            La experiencia de YMC se basó en resolver dos problemas operacionales en momentos distintos del continuo cardiometabólico: antes del diagnóstico y en enfermedad conocida.
          </p>
          
          <div className="flex flex-col md:flex-row gap-8 text-left">
            <div className="flex-1 bg-surface border border-line p-8 rounded-xl">
              <div className="text-[14px] font-extrabold text-brand tracking-widest uppercase mb-4 border-b border-line pb-4">DESAFÍO 1 · ANTES DEL DIAGNÓSTICO</div>
              <p className="text-[16px] text-slate leading-[1.6] mb-4">
                "¿Cómo podríamos identificar de manera más temprana las enfermedades no transmisibles en usuarios y usuarias de APS para su prevención?"
              </p>
            </div>
            <div className="flex-1 bg-surface border border-line p-8 rounded-xl">
              <div className="text-[14px] font-extrabold text-brand tracking-widest uppercase mb-4 border-b border-line pb-4">DESAFÍO 2 · EN ENFERMEDAD CONOCIDA</div>
              <p className="text-[16px] text-slate leading-[1.6] mb-4">
                "¿Cómo optimizar la toma de decisiones en salud preventiva considerando factores sociales y de riesgo para reducir la saturación hospitalaria?"
              </p>
            </div>
          </div>
          
          <div className="mt-8 bg-paper border border-line p-4 rounded-xl text-[14px] text-slate-600 font-medium">
            Nota: Estas preguntas corresponden a los desafíos de innovación que dieron origen a los pilotos. No representan resultados clínicos atribuidos a BAC.
          </div>
        </div>
      </div>
    </section>
  );
}
